import {supabase} from "../../../services/Supabase";

export const NotificationsService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('notifications')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('notifications')
            .select('*')
        return data
    },

    create: async function(site: any) {
        const { data, error } = await supabase
            .from('notifications')
            .insert([
                { id: site.id },
            ])
        return data
    },

    update: async function(id: string, site: any) {
        const { data, error } = await supabase
            .from('notifications')
            .update([
                { ...site },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('notifications')
            .delete()
            .eq('id', id)
        return data
    }
}